import healthCareEntries from 'assets/allBuilderPosts.json';

import ResourceCard from 'molecules/ResourceCard';
import CardListScrollable from 'molecules/ScrollableCardList';

import { convertIdToModelName } from 'utils/builder/builderTemplates';

import type { ResourceCarouselProps } from 'components/ResourceCarousel/config';
import type { FC } from 'react';

type ComponentResourceCarouselProps = Omit<ResourceCarouselProps, 'cards'>;

const ResourceCarousel: FC<ComponentResourceCarouselProps> = ({ title = '' }) => {
  const cards = healthCareEntries;
  const slicedCards = cards.slice(0, 20);

  return (
    <CardListScrollable title={title}>
      {slicedCards?.map(card => {
        const cardTitle = card?.data?.templateInfo?.title || '';
        const model = card?.modelId || '';
        const convertedModelName = convertIdToModelName(model);
        const url = card?.data?.url || null;

        return <ResourceCard key={card?.id} model={convertedModelName} title={cardTitle} link={url} />;
      })}
    </CardListScrollable>
  );
};

export default ResourceCarousel;
